export default "__VITE_ASSET__CX_Kfk$K__"